import React from 'react';
import MatchWithResult from './matchWithResult.js';
import MatchWithoutResult from './matchWithoutResult.js';
import { MATCH_STATUSES, } from '../matchTransformUtil.js';
const { UPCOMING: UPCOMING_MATCH, } = MATCH_STATUSES;
const blockName = 'match-result-component';
export default function MatchResult({ result, status }){
  const isStarted = status !== UPCOMING_MATCH;
  return (
    <div className={ blockName }>
    { isStarted ?
        <MatchWithResult result={ result }/> :
        <MatchWithoutResult /> }
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchResult.js